import React from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'

const useStyles = makeStyles<Theme>((theme) => ({
  text: {
    color: theme.palette.grey[500],
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    padding: '0px 0px 8px 8px',
  },
}))

export default function SectionHeader({ children }) {
  const classes = useStyles()
  return (
    <Text component="p" variant="caption1" className={classes.text}>
      {children}
    </Text>
  )
}
